import React, { useContext, useEffect, useState, useRef, useReducer, useMemo, useCallback } from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest, deleteRequest, tabulatorGet } from '../../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon, EditRowIcon, PaperClipIcon, EditIcon, DeleteIcon, CollapseTreeIcon, ExpandTreeIcon, BranchTreeIcon } from "../../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import { MaintenanceMaskDialogCheckbox } from '../../../components/maintenance/MaintenanceMaskDialogCheckbox';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import { DateTime } from "luxon";
import { OverflowMenuProvider } from '../../../components/toolbar/OverflowMenu';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { PanelMenu } from 'primereact/panelmenu';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import ReactDOMServer from 'react-dom/server';
import { createAsyncNavigateHandlers } from '../../../utils/asyncArrayNavigate';
import { navigationContextToQueryParams } from '../../../utils/maintenanceNavigationContext';
import {
  cleanSorters,
  extractSafePaginationParams,
  createDedupedAjaxRequest,
  refreshProgressiveFromStart,
  mergePagedStandardListFiltersAndSorters,
  appendMaintenanceCompanyCertificateEmbeddedPagedFilter,
  restoreMaintenanceCompanyEmbeddedUserMaskToTable,
  applyMaintenanceCompanyEmbeddedColumnLayout,
} from '../../../utils/tabulatorProgressiveLoading';
import { getPusherChannel } from '../../../utils/pusherChannel';
import { primeMultiSelectHeaderFilter } from '../../../utils/primeMultiSelectHeaderFilter';
import { getEffectiveMask } from '../../../utils/effectiveMask';
import {
  buildMaintenanceMaskAkcieSubItems,
  createConfirmSaveStandardMask,
  createConfirmApplyStandardLayoutToUserMask,
  createSaveUserMaskColumns,
  createOpenMaskDialog,
  createMaskSetFieldHandler,
  createMaskSelectAllHandler,
  createMaskDeselectAllHandler,
  hasApplicableStandardMaskRow,
  MAINTENANCE_MASK_DIALOG_SKIP_FIELDS,
} from '../../../utils/maintenanceTabulatorMaskActions';
import { getTabulatorPersistLayoutEvents } from '../../../utils/tabulatorPersistLayout';
import { inputOnEnterHeaderFilter } from '../../../utils/inputOnEnterHeaderFilter';
import { tabulatorColumnMinWidthFromTitle, TABULATOR_LIST_ID_MIN_WIDTH } from '../../../utils/tabulatorColumnMinWidth';
import {
  buildAuditTabulatorColumns,
  TABULATOR_AUDIT_PROFILES,
} from '../../../utils/tabulatorAuditColumns';
import {
  getEmbeddedCanonicalFieldOrder,
  getEmbeddedDefaultColumnVisibility,
  mergeEmbeddedColumnVisibilityFromSaved,
  applyEmbeddedDataColumnVisibility,
} from '../../../utils/maintenanceCompanyEmbeddedTabulator';
import { LocaleContext } from '../../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../../constants/brandingDisplay';
import {
  buildCanonicalPrintFooterHtml,
  buildCanonicalPrintHeaderHtml,
} from '../../../utils/printChrome';
import { uiT } from '../../../utils/uiTranslate';
import { showDeactivatedInLists } from '../../../utils/moduleSettings';

const MASK_PAGE = 'MaintenanceCompanyCertRecordDetail';
const DEFAULT_COLUMN_VISIBILITY = getEmbeddedDefaultColumnVisibility(MASK_PAGE);
const CANONICAL_FIELD_ORDER = getEmbeddedCanonicalFieldOrder(MASK_PAGE);
const MASK_DIALOG_HELP_TEXT =
  uiT('MaintenanceTemplateList.MaskHelp');

export function isUsableCompanyCertProtocolFileId(file_id) {
    return file_id != null && file_id !== '';
}

export function companyCertRecordProtocolPath(file_id) {
    return `/api/company_cert_records/protocol/${file_id}`;
}

export function openCompanyCertRecordProtocol(file_id, { request, preview, onError } = {}) {
    if (!isUsableCompanyCertProtocolFileId(file_id)) {
        return Promise.resolve();
    }
    return request(companyCertRecordProtocolPath(file_id))
        .then((response) => {
            if (response?.data?.url) {
                preview?.({ url: response.data.url, filename: response.data.filename });
                return;
            }
            onError?.();
        })
        .catch(() => {
            onError?.();
        });
}

export default function MaintenanceCompanyCertRecordDetail({ maintenance_company, type, navigationContext }) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { t } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,setStandardMaskFilter,openFilePreview,getDateFormat, openChosenNotificationPreferences,getUserColor,getUserInitials} = useContext(UtilContext);
    const {user} = useContext(AuthContext);
    const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';

    const canEditCompany = user?.permissions?.includes('edit maintenance-company');
    const hasListNavigationContext = navigationContext != null;

    const [closeTab,setCloseTab] = useState(false);
    const ref = useRef(null);
    const submitRef = useRef(null);
    const overlayRef = useRef(null);
    const [formMaintenanceCompany,setformMaintenanceCompany] = useState(maintenance_company);
    const [formType, setFormType] = useState(type);
    const currentCompanyIdRef = useRef(maintenance_company?.id ?? null);
    const prevCompanyIdRef = useRef(maintenance_company?.id ?? null);

    useEffect(() => {
        if (maintenance_company?.id != null) setformMaintenanceCompany(maintenance_company);
    }, [maintenance_company]);

    const [selectedRecord,setSelectedRecord] = useState(null);

    const [columnsVisible, setColumnsVisible] = useState(() => ({ ...DEFAULT_COLUMN_VISIBILITY }));
    const [maskVisible, setMaskVisible] = useState(false);
//TODO dorobit contractor id
    const [scrollIcons,setScrollIcons] = useState(() => {
        if (type === 'edit' && maintenance_company && navigationContext != null) return !canEditCompany;
        return true;
    });
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    
    const [visibleRecord,setVisibleRecord] = useState(false);
    const [images,setImages] = useState('');
    const [updatefileList, setUpdateFileList] = useState([]);
    const updateFileListRef = useRef(null);
    const [company,setCompany] = useState("");
    const [certificates,setCertificates] = useState([]);
    const [maintenanceCertificates, setMaintenanceCertificates] = useState([]);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const tableBuiltRef = useRef(false);
    const isRestoringRef = useRef(false);
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const dateTimeFmt = `${dateFmt} HH:mm`;
    const canSetStandardMask = user?.permissions?.includes('set standard mask');

    const pageSizePc = useMemo(() => {
      const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
      const n = parseInt(v, 10);
      return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);
    const showDeactivatedCerts = showDeactivatedInLists(state.module_settings, 'maintenance');

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
      const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
      if (extra.size == null) extra.size = pageSizePc;
      extra.type = 'maintenance';
      extra.show_deactivated_certs = showDeactivatedCerts ? '1' : '0';
      const companyId = currentCompanyIdRef.current;
      if (companyId != null) extra.company_id = companyId;
      mergePagedStandardListFiltersAndSorters(extra, {
        getTable,
        tableBuiltForParams: tableBuiltRef.current,
        userMaskFilters: state.user_mask_filters,
        maskPage: MASK_PAGE,
        appendFilter: appendMaintenanceCompanyCertificateEmbeddedPagedFilter,
      });
      return extra;
    }, [pageSizePc, getTable, state.user_mask_filters, showDeactivatedCerts]);

    const fetchPaged = useCallback((url, merged) => {
      return tabulatorGet(url, merged).then((r) => {
        const raw = r?.data ?? [];
        const data = raw.map(c => ({
          ...c,
          cert_description: c.description,
          _children: (c._children || []).map(ch => ({ ...ch, cert_description: c.description })),
        }));
        return { data, last_page: r?.last_page ?? 1, total: r?.total ?? 0 };
      });
    }, []);

    const ajaxRequestFunc = useMemo(
      () => createDedupedAjaxRequest(buildRequestParams, fetchPaged, inFlightRef, completedCacheRef),
      [buildRequestParams, fetchPaged]
    );

    useEffect(() => {
        currentCompanyIdRef.current = formMaintenanceCompany?.id ?? null;
    }, [formMaintenanceCompany?.id]);

    useEffect(() => {
        if (formType === 'edit' && formMaintenanceCompany?.id && hasListNavigationContext) {
            setScrollIcons(!canEditCompany);
        } else {
            setScrollIcons(true);
        }
    }, [formMaintenanceCompany, formType, canEditCompany, hasListNavigationContext]);

    const currentCompanyId = formMaintenanceCompany?.id ?? null;
    useEffect(() => {
      const channel = getPusherChannel();
      if (!channel) return;
      const DEDUPE_MS = 800;
      const lastHandled = { key: '', at: 0 };
      const shouldSkip = (eventType, id) => {
        if (id == null) return true;
        const key = `${eventType}-${id}`;
        const now = Date.now();
        if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
        lastHandled.key = key;
        lastHandled.at = now;
        return false;
      };
      const listType = 'maintenance';
      const isMyType = (p) => p?.type === listType;
      const onCreated = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.created', id)) return;
        getRequest(`/api/company_certificates/${id}`).then((res) => {
          const row = res?.data?.data ?? res?.data ?? res;
          if (!row?.id || row.company_id !== currentCompanyId) return;
          const t = getTable();
          const data = { ...row, cert_description: row.description, _children: (row._children || []).map(ch => ({ ...ch, cert_description: row.description })) };
          const rc = t?.getRow?.(row.id);
          if (rc) rc.update(data).catch(() => {});
          else t?.addData?.([data]);
        }).catch(() => {});
      };
      const onUpdated = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.updated', id)) return;
        getRequest(`/api/company_certificates/${id}`).then((res) => {
          const row = res?.data?.data ?? res?.data ?? res;
          if (!row?.id) return;
          const t = getTable();
          const rc = t?.getRow?.(row.id) ?? t?.getRows?.().find((r) => r.getData?.()?.id === id);
          const data = { ...row, cert_description: row.description, _children: (row._children || []).map(ch => ({ ...ch, cert_description: row.description })) };
          if (row.company_id === currentCompanyId) {
            if (rc) rc.update(data).catch(() => {});
            else t?.addData?.([data]);
          } else if (rc) rc.delete();
        }).catch(() => {});
      };
      const onDeleted = (payload) => {
        if (!isMyType(payload)) return;
        const id = payload?.id;
        if (id == null || shouldSkip('company_certificate.deleted', id)) return;
        const t = getTable();
        const row = t?.getRow?.(id) ?? t?.getRows?.().find((r) => r.getData?.()?.id === id);
        if (row) row.delete();
      };
      const refetch = () => { getTable()?.replaceData?.(); };
      channel.bind('company_certificate.created', onCreated);
      channel.bind('company_certificate.updated', onUpdated);
      channel.bind('company_certificate.deleted', onDeleted);
      channel.bind('company_certificate.activated', refetch);
      channel.bind('company_certificate.deactivated', refetch);
      return () => {
        channel.unbind('company_certificate.created', onCreated);
        channel.unbind('company_certificate.updated', onUpdated);
        channel.unbind('company_certificate.deleted', onDeleted);
        channel.unbind('company_certificate.activated', refetch);
        channel.unbind('company_certificate.deactivated', refetch);
      };
    }, [getTable, currentCompanyId]);

    useEffect(() => {
        getRequest('/api/company_certificates/paged?type=maintenance&size=500&page=1')
            .then((r) => setMaintenanceCertificates(r?.data ?? []))
            .catch(() => setMaintenanceCertificates([]));
    }, []);

    const handleUpdateFileChange = (event) => {
        setUpdateFileList(event.target.files);
    };

    const validate = values => {
        const errors = {};
        return errors;
    };

    const formikUpdate = useFormik({
        initialValues: selectedRecord==null?{
            start_of_validity: '',end_of_validity: '',description:'',certificate_id:''}
            :{
              id:selectedRecord?.id,
              start_of_validity:selectedRecord?.start_of_validity,end_of_validity:selectedRecord?.end_of_validity,
              description:selectedRecord?.description,certificate_id:selectedRecord?.certificate_id
            },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                formData.append(value, values[value] != null ? values[value] : "");
            }
            /*for (var pair of formData.entries()) {
                console.log(pair[0]+ ', ' + pair[1]); 
            }*/
            for(let i = 0;i<updatefileList.length;i++){
              //console.log("IMAGE :"+fileList[i].name);
              formData.append('files[]',updatefileList[i]);
            }
            postRequest(`/api/company_cert_records/update/${formikUpdate.values.id}`, formData,true)
            .then((response) => {
                console.log(response);
                getTable()?.replaceData?.();
                getRequest("/api/companies").then((response) => {
                    dispatch({type:'load_companies',newCompanies:response.data});
                    setVisibleRecord(false);
                    formikUpdate.resetForm();
                    if(updatefileList.length){
                        setUpdateFileList([]);
                        updateFileListRef.current.value = null;
                    }
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                });
            }).catch((reason) => {
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            })
        },
    });

    function hideCertRecord(){
      formikUpdate.resetForm();
      setVisibleRecord(false);
    }

    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingEllipsis')), [getTable]);
    const captureHScroll = useCallback(() => {
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        if (!holder) return;
        savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);
    const restoreHScroll = useCallback(() => {
        if (!savedHScrollRef.current.pending) return;
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        const header = table.columnManager?.contentsElement;
        if (!holder) return;
        const left = savedHScrollRef.current.left;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                holder.scrollLeft = left;
                if (header) header.scrollLeft = left;
                savedHScrollRef.current.pending = false;
            });
        });
    }, [getTable]);

    const resetDetailUiOnNavigate = useCallback(() => {
        setVisibleRecord(false);
        setSelectedRecord(null);
        setImages('');
        setCertificates([]);
        setCompany('');
        setUpdateFileList([]);
        if (updateFileListRef.current) updateFileListRef.current.value = null;
        setEditIcon(true);
        setDeleteIcon(true);
        setCloseTab(false);
        formikUpdate.resetForm();
        getTable()?.deselectRow?.();
    }, [formikUpdate, getTable]);

    useEffect(() => {
        const prevId = prevCompanyIdRef.current;
        const nextId = formMaintenanceCompany?.id;
        if (prevId === nextId) return;
        prevCompanyIdRef.current = nextId;
        if (nextId == null || !tableBuiltRef.current) return;
        inFlightRef.current = { sig: null, promise: null };
        completedCacheRef.current.clear();
        captureHScroll();
        refreshFromStart();
    }, [formMaintenanceCompany?.id, captureHScroll, refreshFromStart]);

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(() => {
        const buildNavigateQueryParams = () => {
            const base = navigationContext ? navigationContextToQueryParams(navigationContext) : '';
            const params = new URLSearchParams(base);
            if (!params.has('type')) {
                params.set('type', 'maintenance');
            }
            return params.toString();
        };
        const applyCompany = (data) => {
            if (!data) return;
            resetDetailUiOnNavigate();
            currentCompanyIdRef.current = data.id ?? null;
            setformMaintenanceCompany(data);
            setFormType('edit');
            setScrollIcons(!canEditCompany);
        };
        const buildFetchRecord = () => async (direction, currentId) => {
            setDialogText?.(t('Common.LoadingData'));
            setVisible?.(true);
            try {
                const q = buildNavigateQueryParams();
                const url = `/api/companies/navigate?direction=${direction}${currentId ? `&id=${currentId}` : ''}${q ? `&${q}` : ''}`;
                const resp = await getRequest(url);
                return resp?.data ?? null;
            } finally {
                setVisible?.(false);
            }
        };
        return createAsyncNavigateHandlers(
            buildFetchRecord(),
            applyCompany,
            () => currentCompanyIdRef.current ?? formMaintenanceCompany?.id
        );
    }, [navigationContext, formMaintenanceCompany?.id, canEditCompany, resetDetailUiOnNavigate, setDialogText, setVisible]);

    const onSelectRow =  (data, rows) => {
      setDeleteIcon(true);
      setEditIcon(true);
      formikUpdate.resetForm();
      if(data.length>0){
          let children = 0;
          let parent = 0;
          data.forEach(obj => {
              if(obj?.certificate_id>0){
                  children++;
              }
              else parent++;
          });
          if(children>0 && parent==0){
            console.log(user.permissions);
              if(user.permissions?.includes("delete maintenance-company"))setDeleteIcon(false);
              if(data?.length==1 && user.permissions?.includes("edit maintenance-company")){
                  setSelectedRecord(data[0]);
                  formikUpdate.setValues(data[0]);
                  setEditIcon(false);
              }
          }
      }
    }

    function getRecordFiles(id){
        getRequest(`/api/company_cert_records/protocols/${id}`).then((response) => {
            console.log(response);
            if(response.data!=="{}")setImages(response.data);
        });
    }
    
    const acceptFile = (id) => {
        getRequest(`/api/company_cert_records/deleteProtocol/${id}`)
        .then((response) => {
            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.FileDeletedDetail') });
            getRecordFiles(selectedRecord?.id);
        }).catch((reason) => {
            alert(reason);
            toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.FileDeleteFailedDetail'), life: 3000 });
        })
    };
    

    function deleteFiles(img){
      confirmDialog({
          message: t('Common.ConfirmDeleteFile'),
          header: t('Common.ConfirmDelete'),
          icon: 'pi pi-info-circle',
          acceptClassName: 'p-button-danger',
          acceptLabel: t('Common.No'),
          rejectLabel: t('Common.Yes'),
          accept:reject,
          reject:() => acceptFile(img.id)
      });
    }

    function NameFormatter(props) {
      const rowData = props.cell.getRow().getData();
      var parent = props.cell.getRow()?.getTreeParent();
      if(rowData?._children) return <div className='training_name'>{rowData.name}</div>;
      if(parent){
          let parent_array = parent._row.data._children;
          for(let i = 0;i<parent_array.length;i++){
              if(parent_array[i].id == rowData.id){
                  if(i==parent_array.length-1)return <div className='training_name'>Prvotný certifikát</div>;
                  else return <div className='training_name'>{parent_array.length-1-i}. Opakovaný certifikát</div>;
              }
          }
          return <div className='training_name'>{parent._row.data.name}</div>;
      }
      return "";
  }  

    function viewFile(file_id){
        return openCompanyCertRecordProtocol(file_id, {
            request: getRequest,
            preview: openFilePreview,
            onError: () => {
                toast?.current?.show({
                    severity: 'warn',
                    summary: t('Common.Rejected'),
                    detail: t('Common.Toast.ActionFailedDetail'),
                    life: 3000,
                });
            },
        });
    }

      function Protocol(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.files) return <div className='flex flex-row'>{rowData.files.map((img) => (<a style={{color:'blue',cursor:'pointer',marginBottom:'2px',width: '24px',display: 'block'}} onClick={() => {viewFile(img.id);}}><PaperClipIcon/></a>))}</div>;
        if(rowData?._children.length > 0 && rowData._children[0]?.files?.length > 0) return <div className='flex flex-row'>{rowData._children[0]?.files.map((img) => (<a style={{color:'blue',cursor:'pointer',marginBottom:'2px',width: '24px',display: 'block'}} onClick={() => {viewFile(img.id);}}><PaperClipIcon/></a>))}</div>;
        return "";
    }

    function EndOfValidity(props){
        const rowData = props.cell.getRow().getData();
        if(rowData?.end_of_validity) return DateTime.fromISO(rowData.end_of_validity).toFormat(dateFmt);
        if(rowData?._children.length > 0) return DateTime.fromISO(rowData._children[0].end_of_validity).toFormat(dateFmt);
        return <span className='text-red-500'>{t('Ui.R67.Necertifikovane')}</span>;
    }

    function StartOfValidity(props){
        const rowData = props.cell.getRow().getData();
        if(rowData?.start_of_validity) return DateTime.fromISO(rowData.start_of_validity).toFormat(dateFmt);
        if(rowData?._children.length > 0) return DateTime.fromISO(rowData._children[0].start_of_validity).toFormat(dateFmt);
        return <span className='text-red-500'>{t('Ui.R67.Necertifikovane')}</span>;
    }

    function StateFormatter(props){
      const rowData = props.cell.getRow().getData();
      var parent = props.cell.getRow()?.getTreeParent();
      if(parent){
          let parent_array = parent._row.data._children;
          for(let i = 0;i<parent_array.length;i++){
              if(parent_array[i].id == rowData.id){
                  if(i==parent_array.length-1){
                      if(new Date(parent_array[i]?.end_of_validity) < new Date()){
                          return "NOK";
                      }
                      else return "OK";
                  }
                  else return "OK";
              }
          }
      }
      if(rowData?._children?.length > 0){           
          if(new Date(rowData?._children[0]?.end_of_validity) < new Date()){
              return "NOK";
          }
          return "OK"
      }
      else return "NOK";
    }

    function CertDescriptionFormatter(props){
        const rowData = props.cell.getRow().getData();
        return rowData?.description;
      }

    function CertificateStatusFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const v = rowData?._children?.length > 0 ? rowData._children[0]?.deactivation_date : rowData?.deactivation_date;
        return <span>{v ? t('Status.Deactivated') : 'Aktívny'}</span>;
    }
    function ResponsibleFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const name = rowData?._children?.length > 0 ? (rowData._children[0]?.responsible?.name ?? '—') : (rowData?.responsible?.name ?? '—');
        return <span>{name}</span>;
    }
    const remoteHeaderFilter = useCallback(() => true, []);

    const auditTailColumns = useMemo(
      () =>
        buildAuditTabulatorColumns({
          profile: TABULATOR_AUDIT_PROFILES.createdByUpdatedBy,
          includeId: false,
          dateFormat: dateFmt,
          dateTimeFormat: dateTimeFmt,
          getUserColor,
          getUserInitials,
          textHeaderFilter: inputOnEnterHeaderFilter,
          remotePassthrough: true,
        }),
      [dateFmt, dateTimeFmt, getUserColor, getUserInitials]
    );

    const columns = useMemo(
      () => [
        {
          title: '',
          field: 'rowSelection',
          formatter: 'rowSelection',
          titleFormatter: 'rowSelection',
          titleFormatterParams: { rowRange: 'active' },
          hozAlign: 'center',
          width: 44,
          minWidth: 44,
          headerSort: false,
          resizable: false,
          frozen: true,
          print: false,
          download: false,
          cellClick: (e, cell) => {
            cell.getRow().toggleSelect();
          },
        },
        {
          title: 'ID',
          field: 'id',
          headerFilter: inputOnEnterHeaderFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: remoteHeaderFilter,
          minWidth: TABULATOR_LIST_ID_MIN_WIDTH,
          widthGrow: 1,
          sorter: 'number',
          hozAlign: 'left',
        },
        {
          title: t('Common.Name'),
          field: 'name',
          formatter: reactFormatter(<NameFormatter />),
          headerFilter: inputOnEnterHeaderFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: remoteHeaderFilter,
          minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Name')),
          widthGrow: 1,
        },
        {
          title: t('Common.Description'),
          field: 'description',
          headerFilter: inputOnEnterHeaderFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: remoteHeaderFilter,
          minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Description')),
          widthGrow: 1,
        },
        {
          title: t('Common.ValidFrom'),
          field: 'custom_start_of_validity',
          headerFilter: inputOnEnterHeaderFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: remoteHeaderFilter,
          minWidth: tabulatorColumnMinWidthFromTitle(t('Common.ValidFrom')),
          widthGrow: 1,
          formatter: reactFormatter(<StartOfValidity />),
        },
        {
          title: t('Common.ValidTo'),
          field: 'custom_end_of_validity',
          headerFilter: inputOnEnterHeaderFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: remoteHeaderFilter,
          minWidth: tabulatorColumnMinWidthFromTitle(t('Common.ValidTo')),
          widthGrow: 1,
          formatter: reactFormatter(<EndOfValidity />),
        },
        {
          title: t('Common.CertificateDescription'),
          field: 'cert_description',
          formatter: reactFormatter(<CertDescriptionFormatter />),
          headerFilter: inputOnEnterHeaderFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: remoteHeaderFilter,
          minWidth: tabulatorColumnMinWidthFromTitle(t('Common.CertificateDescription')),
          widthGrow: 1,
        },
        {
          title: t('Common.CertificateStatus'),
          field: 'certificate_status',
          headerFilter: primeMultiSelectHeaderFilter,
          headerFilterParams: {
            options: [
              { label: 'Aktívny', value: 'Aktívny' },
              { label: t('Status.Deactivated'), value: "Deaktivovaný" },
            ],
            placeholder: t('Common.CertificateStatus'),
          },
          headerFilterFunc: remoteHeaderFilter,
          minWidth: tabulatorColumnMinWidthFromTitle(t('Common.CertificateStatus'), 'multiselect'),
          formatter: reactFormatter(<CertificateStatusFormatter />),
        },
        {
          title: t('Common.Column.Responsible'),
          field: 'responsible.name',
          formatter: reactFormatter(<ResponsibleFormatter />),
          headerFilter: inputOnEnterHeaderFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: remoteHeaderFilter,
          minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Column.Responsible')),
          widthGrow: 1,
        },
        {
          title: t('Common.Status'),
          field: 'state',
          headerFilter: primeMultiSelectHeaderFilter,
          headerFilterParams: {
            options: [
              { label: 'OK', value: 'OK' },
              { label: 'NOK', value: 'NOK' },
            ],
            placeholder: t('Common.Status'),
          },
          headerFilterFunc: remoteHeaderFilter,
          minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Status'), 'multiselect'),
          widthGrow: 1,
          formatter: reactFormatter(<StateFormatter />),
        },
        {
          title: 'Protokol',
          field: 'protocol',
          headerFilter: inputOnEnterHeaderFilter,
          headerFilterLiveFilter: false,
          headerFilterFunc: remoteHeaderFilter,
          minWidth: tabulatorColumnMinWidthFromTitle('Protokol'),
          widthGrow: 1,
          formatter: reactFormatter(<Protocol />),
        },
        ...auditTailColumns,
      ],
      [auditTailColumns, remoteHeaderFilter]
    );

    const closeMenu = useCallback(() => {
      setTimeout(() => {
        OverflowMenuProvider.setVisible?.(null);
        setExpandedKeys({});
      }, 0);
    }, []);

    const hasApplicableStandardMask = useMemo(
      () => hasApplicableStandardMaskRow(state.standard_mask_filters, MASK_PAGE, (saved) => mergeEmbeddedColumnVisibilityFromSaved(MASK_PAGE, saved)),
      [state.standard_mask_filters]
    );

    const openMaskDialog = useCallback(
      createOpenMaskDialog({
        columnsVisible,
        setColumnsVisible,
        defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
        mergeVisibilityFromSaved: (saved) => mergeEmbeddedColumnVisibilityFromSaved(MASK_PAGE, saved),
        setMaskVisible,
        closeMenu,
      }),
      [columnsVisible, closeMenu]
    );

    const saveUserMaskColumns = useCallback(
      createSaveUserMaskColumns({
        maskPage: MASK_PAGE,
        getTable,
        setUserMaskFilter,
        defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
        columnsVisible,
        setColumnsVisible,
        setMaskVisible,
        toast,
      }),
      [columnsVisible, getTable, setUserMaskFilter, toast]
    );

    const confirmSaveStandardMask = useCallback(
      createConfirmSaveStandardMask({
        maskPage: MASK_PAGE,
        getTable,
        setStandardMaskFilter,
        defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
        toast,
      }),
      [getTable, setStandardMaskFilter, toast]
    );

    const confirmApplyStandardLayoutToUserMask = useCallback(
      createConfirmApplyStandardLayoutToUserMask({
        maskPage: MASK_PAGE,
        state,
        setUserMaskFilter,
        defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
        mergeVisibilityFromSaved: (saved) => mergeEmbeddedColumnVisibilityFromSaved(MASK_PAGE, saved),
        toast,
        closeMenu,
        onAppliedToTable: ({ colsForSave, attributes }) => {
          const table = getTable();
          if (!table) return;
          isRestoringRef.current = true;
          applyMaintenanceCompanyEmbeddedColumnLayout(table, attributes, CANONICAL_FIELD_ORDER);
          setColumnsVisible(colsForSave);
          applyEmbeddedDataColumnVisibility(table, MASK_PAGE, colsForSave);
          setTimeout(() => {
            isRestoringRef.current = false;
            table.redraw?.(true);
            captureHScroll();
            refreshFromStart();
          }, 0);
        },
      }),
      [state, closeMenu, getTable, setUserMaskFilter, toast, captureHScroll, refreshFromStart]
    );

    const setMask = useCallback(
      createMaskSetFieldHandler({
        defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
        columnsVisible,
        setColumnsVisible,
        getTable,
        applyVisibilityToTable: (table, vis) => applyEmbeddedDataColumnVisibility(table, MASK_PAGE, vis),
        toast,
      }),
      [columnsVisible, getTable, toast]
    );

    const maskSelectAll = useCallback(
      createMaskSelectAllHandler({
        defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
        setColumnsVisible,
        getTable,
        applyVisibilityToTable: (table, vis) => applyEmbeddedDataColumnVisibility(table, MASK_PAGE, vis),
      }),
      [getTable]
    );

    const maskDeselectAll = useCallback(
      createMaskDeselectAllHandler({
        defaultColumnVisibility: DEFAULT_COLUMN_VISIBILITY,
        setColumnsVisible,
        getTable,
        applyVisibilityToTable: (table, vis) => applyEmbeddedDataColumnVisibility(table, MASK_PAGE, vis),
      }),
      [getTable]
    );

      const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );
    
      const [expandedKeys, setExpandedKeys] = useState({});
    
      const handleClickOutside = (event) => {
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
        }
      };
    
      useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
  
    

    const akcieSubItems = buildMaintenanceMaskAkcieSubItems({
      maskPage: MASK_PAGE,
      getTable,
      setUserMaskFilter,
      cleanSorters,
      captureHScroll,
      refreshFromStart,
      closeMenu,
      openMaskDialog,
      openChosenNotificationPreferences,
      hasApplicableStandardMask,
      confirmApplyStandardLayoutToUserMask,
      itemRenderer,
    });

    const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: akcieSubItems,
      },
    ];

      const reject = () => {
          toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
      }

    const acceptCertificate = () => {
        const rows_to_delete = getTable()?.getSelectedData?.() ?? [];
        rows_to_delete.forEach(element => {
          deleteRequest(`/api/company_cert_records/${element.id}`)
              .then((response) => {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
                getTable()?.replaceData?.();
              }).catch((reason) => {
                  alert(reason);
                  toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
              })
        });
    }

      const confirm = () => {
        confirmDialog({
            message: t('Common.ConfirmDeleteRecord'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept: reject,
            reject: acceptCertificate
        });
    };

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'> 
            <IntersectionObserverWrapper>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => {getRecordFiles(selectedRecord?.id);setVisibleRecord(true);}}><EditIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="print"><button onClick={() => getTable()?.print?.(false, true)}><PrintIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => { captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button className="disabled:opacity-25" type="button" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button className="disabled:opacity-25" type="button" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button className="disabled:opacity-25" type="button" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button className="disabled:opacity-25" type="button" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled onClick={() => openFavoriteDialog(t('Maintenance.ServiceCompanyCertValidity'),"MaintenanceCompanyCertRecordDetail")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="price"><button className="disabled:opacity-25" disabled onClick={() => setFastView("MaintenanceCompanyCertRecordDetail",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          {canSetStandardMask ? (
            <div className="flex w-10 h-10 px-2 py-1 justify-center" data-targetid="save-standard-mask">
              <button
                type="button"
                title={t('Common.SaveStandardMask')}
                aria-label={t('Common.SaveStandardMask')}
                onClick={confirmSaveStandardMask}
                className="flex items-center justify-center"
              >
                <i className="pi pi-bookmark text-white text-xl" aria-hidden="true" />
              </button>
            </div>
          ) : null}
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
        </div>
        <Splitter className='h-[calc(100vh_-_177px)]' layout="vertical" pt={{ gutter: { className: 'bg-[#333] h-8' },gutterHandler: { className: 'bg-secondary ' } }}>
        <SplitterPanel className="flex align-items-center justify-content-center overflow-y-auto " minSize={10} size={63}>
        <div className="w-full relative flex flex-col h-full overflow-x">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.PLATNOST_CERTIFIKATOV_SKOLIACEJ_FIRMY')}</h1>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">Por.č.: {formMaintenanceCompany?.id}</label>}
                      <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.CompanyNameUpper')}</label>
                        <input
                        readOnly={true}
                            name='name'
                            type="text"
                            value={formMaintenanceCompany?.name}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="tel_number"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.PhoneNumber')}</label>
                        <input
                        readOnly={true}
                            name='tel_number'
                            type="text"
                            value={formMaintenanceCompany?.tel_number}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    
                      <div>
                        <label
                            htmlFor="email"
                            className="block text-md font-semibold text-gray-800"
                        >
                            E-MAIL
                        </label>
                        <input
                        readOnly={true}
                            name='email'
                            type="text"
                            value={formMaintenanceCompany?.email}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="contact_person"
                            className="block text-md font-semibold text-gray-800 mt-2"
                        >{t('Common.ContactPersonUpper')}</label>
                        <input
                        readOnly={true}
                            name='contact_person'
                            type="text"
                            value={formMaintenanceCompany?.contact_person}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>        
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                    <div>
                        <label
                            htmlFor="address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            ADRESA
                        </label>
                        <input
                        readOnly={true}
                            name='address'
                            type="text"
                            value={formMaintenanceCompany?.address}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="fax"
                            className="block text-md font-semibold text-gray-800"
                        >
                             FAX
                        </label>
                        <input
                        readOnly={true}
                            name='fax'
                            type="text"
                            value={formMaintenanceCompany?.fax}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="web_address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            WEB. ADRESA
                        </label>
                        <input
                        readOnly={true}
                            name='web_address'
                            type="text"
                            value={formMaintenanceCompany?.web_address}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.NoteUpper')}</label>
                        <textarea
                        readOnly={true}
                            name='gauge_name'
                            type="text"
                            value={formMaintenanceCompany?.description}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div>    
            </div> 
            </div>
            </div> 
             </SplitterPanel>
             <SplitterPanel className="flex flex-col align-items-center justify-content-center w-full overflow-y-auto" size={37} style={{minHeight: '110px'}}>
             <ReactTabulator
               key={`maintenance-cert-record-detail-${formMaintenanceCompany?.id}`}
               data={undefined}
               className='h-[calc(100vh_-_176px)]'
               onRef={(r) => (ref.current = r?.current)}
               columns={columns}
               events={{
                 rowSelectionChanged: onSelectRow,
                 headerFilterChanged: () => {
                   if (!isRestoringRef.current) {
                     captureHScroll();
                     refreshFromStart();
                   }
                 },
                 sortChanged: () => {
                   if (!isRestoringRef.current) {
                     captureHScroll();
                     refreshFromStart();
                   }
                 },
                 renderComplete: () => restoreHScroll(),
                 tableBuilt: () => {
                    const t = getTable();
                    if (!t) return;
                    isRestoringRef.current = true;
                    const effective = getEffectiveMask(MASK_PAGE, state);
                    if (effective?.type === 'user' && effective.userMask) {
                      restoreMaintenanceCompanyEmbeddedUserMaskToTable(t, effective.userMask, {
                        canonicalFieldOrder: CANONICAL_FIELD_ORDER,
                        setColumnsVisible,
                        applyColumnVisibilityFn: (table, cols) => {
                          const merged = mergeEmbeddedColumnVisibilityFromSaved(MASK_PAGE, cols);
                          setColumnsVisible(merged);
                          applyEmbeddedDataColumnVisibility(table, MASK_PAGE, merged);
                        },
                      });
                    } else if (effective?.type === 'standard' && effective.standardMask) {
                      restoreMaintenanceCompanyEmbeddedUserMaskToTable(t, effective.standardMask, {
                        canonicalFieldOrder: CANONICAL_FIELD_ORDER,
                        setColumnsVisible,
                        applyColumnVisibilityFn: (table, cols) => {
                          const merged = mergeEmbeddedColumnVisibilityFromSaved(MASK_PAGE, cols);
                          setColumnsVisible(merged);
                          applyEmbeddedDataColumnVisibility(table, MASK_PAGE, merged);
                        },
                      });
                    } else {
                      applyEmbeddedDataColumnVisibility(t, MASK_PAGE, columnsVisible);
                    }
                    setTimeout(() => {
                      isRestoringRef.current = false;
                    }, 0);
                    tableBuiltRef.current = true;
                    refreshFromStart();
                  },
                 ...getTabulatorPersistLayoutEvents(MASK_PAGE, ref, setUserMaskFilter),
               }}
               options={{
                renderHorizontal:"virtual",rowHeight:42,movableColumns: true,headerSortTristate:true,layout:'fitColumns',
                dataTree:true,dataTreeStartExpanded:false,dataTreeFilter:false,dataTreeElementColumn: "name",
                dataTreeCollapseElement:ReactDOMServer.renderToStaticMarkup(<CollapseTreeIcon/>),
                dataTreeExpandElement:ReactDOMServer.renderToStaticMarkup(<ExpandTreeIcon/>),
                dataTreeBranchElement:ReactDOMServer.renderToStaticMarkup(<BranchTreeIcon/>),
                ajaxURL: '/api/company_certificates/paged',
                progressiveLoad: 'scroll',
                progressiveLoadScrollMargin: 80,
                paginationSize: pageSizePc,
                pagination: false,
                filterMode: 'remote',
                sortMode: 'remote',
                ajaxRequestFunc,
                dataLoader: true,
                dataLoaderLoading: t('Common.LoadingData'),
                dataLoaderError: t('Common.LoadFailed'),
                printAsHtml:true,printRowRange:"active",printCopyStyle:true,printHeader: () => buildCanonicalPrintHeaderHtml({
                      branding: state?.branding,
                      productFallbackSrc: defaultProductLogoSrc,
                      companySettingsPrint: state?.company_settings_print,
                      moduleSettings: state?.module_settings,
                      title: t('Print.Title.MaintenanceCompanyCertRecordDetail'),
                      printDateLabel: t('Print.DateLabel'),
                    }),
                    printFooter: () => buildCanonicalPrintFooterHtml({
                      companySettingsPrint: state?.company_settings_print,
                    }),
               }}/>
            </SplitterPanel>
            </Splitter>
            </div>
            <Dialog header={t('Common.EditCertificateRecord')} visible={visibleRecord} style={{ width: '40vw' }} onHide={() => hideCertRecord()}>
              <form onSubmit={formikUpdate.handleSubmit}>
                  <div>
                    <label
                        htmlFor="certificate_id"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Ui.R67.Certifikat_kal_firmy')}</label>
                    <select 
                    disabled
                    name="certificate_id"
                    onChange={formikUpdate.handleChange} value={formikUpdate.values.certificate_id} 
                    className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                      <option value="">{t('Ui.R67.Vyber_certifikat')}</option>
                      {maintenanceCertificates.map((certificate) => (
                        <option key={certificate.id} value={certificate.id}>{certificate.name}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label
                        htmlFor="start_of_validity"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Ui.R67.Datum_platnosti_od')}</label>
                    <input
                        name='start_of_validity'
                        type="date" required
                        onChange={formikUpdate.handleChange} value={formikUpdate.values.start_of_validity}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                    </div>
                    <div>
                    <label
                        htmlFor="end_of_validity"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Ui.R67.Datum_platnosti_do')}</label>
                    <input
                        name='end_of_validity'
                        type="date" required
                        onChange={formikUpdate.handleChange} value={formikUpdate.values.end_of_validity}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                    </div>
                    <div>
                    <label
                        htmlFor="description"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Common.Note')}</label>
                    <textarea
                        name='description'
                        type="text"
                        onChange={formikUpdate.handleChange} value={formikUpdate.values.description}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    >
                    </textarea>
                    </div> 
                      <div>
                      <label
                          htmlFor="files"
                          className="block text-md font-semibold text-gray-800"
                      >
                          PROTOKOL
                      </label>
                      <input
                          name='files' 
                          accept='image/*,application/pdf'
                          ref={updateFileListRef}
                          onChange={handleUpdateFileChange}
                          className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                          type='file'
                          multiple="multiple"
                          id='file'/>
                      </div> 
                      {images!=='' && images.map((img) => ( <div key={img.id} className='flex flex-row p-2'>
                          <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })} className="cursor-pointer">
                              {/\.(pdf|png|jpg|jpeg|gif|webp|bmp|svg|img)$/i.test(img.filename || '') ? (
                                  <embed src={img.url+'#view=FitH&scrollbar=0'} width="100px" height="65px" />
                              ) : (
                                  <div className="w-[100px] h-[65px] flex items-center justify-center bg-gray-100 border rounded"><PaperClipIcon /></div>
                              )}
                          </div>
                              <div className='flex flex-col ml-4'>
                              <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>{img.filename}</a>
                              <button type="button" className='w-fit flex flex-row px-2 py-1 border rounded-md bg-red-900' onClick={() => deleteFiles(img)} ><DeleteIcon/><span className='text-white ml-1'>{t('Common.Clear')}</span></button>
                              </div>
                          </div>))}
                      <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
                  </form>
              </Dialog>
      <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
          <p className="text-sm text-gray-600 mb-2">{MASK_DIALOG_HELP_TEXT}</p>
          <div className="flex flex-wrap gap-2 mb-2">
            <button type="button" onClick={maskSelectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.SelectAll')}</button>
            <button type="button" onClick={maskDeselectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.DeselectAllExceptId')}</button>
          </div>
          {columns.map((item) => {
            if (!item?.field || MAINTENANCE_MASK_DIALOG_SKIP_FIELDS.has(item.field)) return null;
            const field = String(item.field);
            const inputId = `${MASK_PAGE}-${field}`;
            return (
              <div key={field} className="flex flex-row border border-black rounded-md p-2 m-1">
                <MaintenanceMaskDialogCheckbox field={field} inputId={inputId} title={item.title} columnsVisible={columnsVisible} onChange={setMask} />
                <label htmlFor={inputId} className={`ml-2 ${field === 'id' ? '' : 'cursor-pointer'}`}>{item.title}</label>
              </div>
            );
          })}
          <button type="button" onClick={saveUserMaskColumns} className="m-1 px-4 py-2 bg-zinc-900 text-white rounded-md hover:bg-zinc-700">{t('Common.SaveUpper')}</button>
        </div>
      </Dialog>
</> 
            );
} 
